import './PaymentStep.scss';
import React, { useEffect } from 'react';
import 'moment-timezone';
import { Grid, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StripePaymentFrame } from './payments/StripePaymentFrame';
import { OrderPageTypography } from '../themedComponents/OrderPageTypography';
import { AccountIframeSettingsData } from '../../api';
import { useLanguage } from '../../common/GeneralUtils';

const urlHeightResolver = (
  paymentUrl: string,
  isSmallScreen: boolean,
  paymentIframeSettings?: AccountIframeSettingsData,
) => {
  if (paymentIframeSettings?.desktop_height && !isSmallScreen) {
    return paymentIframeSettings?.desktop_height;
  }
  if (paymentIframeSettings?.mobile_height && isSmallScreen) {
    return paymentIframeSettings?.mobile_height;
  }

  if (paymentUrl.includes('payplus')) {
    return '710px';
  }
  if (paymentUrl.includes('payme')) {
    return isSmallScreen ? '700px' : '440px';
  }
  if (paymentUrl.includes('meshulam')) {
    return isSmallScreen ? '363px' : '480px';
  }
  if (paymentUrl.includes('tranzila')) {
    return isSmallScreen ? '600px' : '500px';
  }

  return '700px';
};
const PaymentIframe = ({
  paymentUrl,
  stripe_integration_publishable_key,
  stripeAccountId,
  paymentIframeSettings,
  allowedToShowButton,
}: {
  paymentUrl: string;
  stripeAccountId?: string;
  stripe_integration_publishable_key?: string;
  paymentIframeSettings?: AccountIframeSettingsData;
  allowedToShowButton?: boolean; // hack in iframes without colors to hide button
}) => {
  const { t } = useTranslation();

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const language = useLanguage();

  useEffect(() => {
    // Payplus integration doesn't seem to remove it in orderpagecompleted is it moves us out of the iframe.
    // removing it here means that refreshing the page is going to forget the order, which is fine.
    // updaate 2024-5-21 tested and it doesn't seem to issue so commented out the code for now.
    if (paymentUrl?.includes('payplus')) {
      // TTLLocalStorage.removeByPrefix('order-page-state-');
    }
  }, []);

  if (stripe_integration_publishable_key) {
    return (
      <StripePaymentFrame
        publishableKey={stripe_integration_publishable_key}
        clientSecret={paymentUrl}
        stripeAccountId={stripeAccountId}
      />
    );
  }

  return (
    <Grid container flexDirection="column">
      {paymentIframeSettings?.note?.[language] && (
        <Grid item mt={3}>
          <OrderPageTypography bold>{paymentIframeSettings?.note?.[language]}</OrderPageTypography>
        </Grid>
      )}

      <iframe
        style={{
          borderRadius: '8px',
          border: `1px solid ${theme.customTheme.palette.border}`,
          backgroundColor: 'white',
        }}
        height={urlHeightResolver(paymentUrl, isSmallScreen, paymentIframeSettings)}
        title="payment-iframe"
        src={paymentUrl}
        className="payment-iframe"
      />
    </Grid>
  );
};

export default PaymentIframe;
